module.exports = __webpack_public_path__ + "img/layout_thumb_bottom.b7b36405.png";